import { render, staticRenderFns } from "./ArticleGrayPanel.vue?vue&type=template&id=42dec269&scoped=true&"
import script from "./ArticleGrayPanel.vue?vue&type=script&lang=js&"
export * from "./ArticleGrayPanel.vue?vue&type=script&lang=js&"
import style0 from "./ArticleGrayPanel.vue?vue&type=style&index=0&id=42dec269&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42dec269",
  null
  
)

export default component.exports